import { CustomerGenders } from "@nxplatform/platform-entities";
import { OddsFormatOptions, AsideGlobalSettingsType } from "@nxplatform/platform-entities/customer/preferences";
import { __ } from "@service/api-client/http/helpers/translates";
import { CustomerHaveEstoniaPersonalCode } from "../entities/common-entities.js";
import { hongKongFromDecimal, indonesianFromDecimal, malaysianFromDecimal, fractionalFromDecimal, usFromDecimal } from "../factor/converter/factor-odds-converter.js";
const customerPaymentMethods = "customer_payment_methods";
const customerAuthProvider = "customer_auth_provider";
const customerLastConnectionInfo = "customer_last_connection_info";
const personalCodePlaceholders = () => ({
  EE: __("Registration_._Form_._ID number"),
  LV: __("Registration_._Form_._Personal ID")
});
const provincePlaceholders = () => ({
  // __('Registration_._Form_._State');
  AU: __("Registration_._Form_._Region")
});
const genderItems = () => [
  { id: CustomerGenders.male, text: __("Registration_._Form_._Male") },
  { id: CustomerGenders.female, text: __("Registration_._Form_._Female") }
];
const genderItemsWithOther = () => [
  ...genderItems(),
  { id: CustomerGenders.other, text: __("Registration_._Form_._Other") }
];
const yesNoItems = () => [
  { id: CustomerHaveEstoniaPersonalCode.yes, text: __("Registration_._Form_._Yes") },
  { id: CustomerHaveEstoniaPersonalCode.no, text: __("Registration_._Form_._No") }
];
const getProvincePlaceholder = (country) => provincePlaceholders()[country.toUpperCase()] || __("Registration_._Form_._Province");
const baseCountrySetupEntity = {
  countryWithPC: false,
  personalCodeMinLength: null,
  personalCodeMaxLength: null,
  postCodeNotRequired: false
};
const countrySetupMap = {
  EE: {
    countryWithPC: true,
    personalCodeMinLength: 11,
    personalCodeMaxLength: 11
  },
  LV: {
    countryWithPC: true,
    personalCodeMinLength: 11,
    personalCodeMaxLength: 11
  },
  IE: {
    postCodeNotRequired: true
  }
};
const getCountrySetup = (country) => ({
  ...baseCountrySetupEntity,
  ...country && countrySetupMap[country.toUpperCase()] || {}
});
const widgetMinimized = "widgetMaximized";
const selfExclusion = "selfExclusion";
const isFirstCashierOpened = "isFirstCashierOpened";
const registrationComplete = "registrationComplete";
const getOddsFormat = () => [
  {
    id: OddsFormatOptions.ODDS_FORMAT_DECIMAL,
    text: __("Odds Format_._Type_._Decimal format"),
    format: "1.90"
  },
  {
    id: OddsFormatOptions.ODDS_FORMAT_AMERICAN,
    text: __("Odds Format_._Type_._American format"),
    format: "+/-"
  },
  {
    id: OddsFormatOptions.ODDS_FORMAT_FRACTIONAL,
    text: __("Odds Format_._Type_._Fractional format"),
    format: "6/1"
  },
  {
    id: OddsFormatOptions.ODDS_FORMAT_MALAYSIAN,
    text: __("Odds Format_._Type_._Malaysian odds"),
    format: "-0.834"
  },
  {
    id: OddsFormatOptions.ODDS_FORMAT_INDONESIAN,
    text: __("Odds Format_._Type_._Indonesian odds"),
    format: "+1.20"
  },
  {
    id: OddsFormatOptions.ODDS_FORMAT_HONG_KONG,
    text: __("Odds Format_._Type_._Hong Kong odds"),
    format: "1.20"
  }
];
const OddsFormatMap = {
  [OddsFormatOptions.ODDS_FORMAT_DECIMAL]: "decimal",
  [OddsFormatOptions.ODDS_FORMAT_AMERICAN]: "american",
  [OddsFormatOptions.ODDS_FORMAT_FRACTIONAL]: "fraction",
  [OddsFormatOptions.ODDS_FORMAT_MALAYSIAN]: "malaysian",
  [OddsFormatOptions.ODDS_FORMAT_INDONESIAN]: "indo",
  [OddsFormatOptions.ODDS_FORMAT_HONG_KONG]: "hongkong"
};
const asideGlobalSettingsList = (sportSettings, isAuth) => {
  const settingsList = [
    {
      type: AsideGlobalSettingsType.oddsFormat,
      text: __("Settings_._Settings List Item_._Odds format"),
      isVisible: sportSettings.oddsFormatPickerEnabled
    },
    {
      type: AsideGlobalSettingsType.acceptingBets,
      text: __("Settings_._Settings List Item_._Accepting Bets"),
      isVisible: sportSettings.acceptBetsPickerEnabled && isAuth
    },
    {
      type: AsideGlobalSettingsType.betAmount,
      text: __("Settings_._Settings List Item_._Bet Amount"),
      isVisible: sportSettings.lastBetSumToggleEnabled && isAuth
    }
  ];
  return settingsList;
};
const factorValuesMapper = {
  [OddsFormatOptions.ODDS_FORMAT_AMERICAN]: usFromDecimal,
  [OddsFormatOptions.ODDS_FORMAT_FRACTIONAL]: fractionalFromDecimal,
  [OddsFormatOptions.ODDS_FORMAT_MALAYSIAN]: malaysianFromDecimal,
  [OddsFormatOptions.ODDS_FORMAT_INDONESIAN]: indonesianFromDecimal,
  [OddsFormatOptions.ODDS_FORMAT_HONG_KONG]: hongKongFromDecimal
};
const oddsStorageKey = "customer_odds";
const timeZoneStorageKey = "timeZone";
const timeFormatStorageKey = "timeFormat";
const cryptoAlternativeStorageKey = "cryptoAlternative";
const hideZeroBalancesStorageKey = "hideZeroBalances";
const quickBetSumsStorageKey = "quickBetSums";
export {
  OddsFormatMap,
  asideGlobalSettingsList,
  countrySetupMap,
  cryptoAlternativeStorageKey,
  customerAuthProvider,
  customerLastConnectionInfo,
  customerPaymentMethods,
  factorValuesMapper,
  genderItems,
  genderItemsWithOther,
  getCountrySetup,
  getOddsFormat,
  getProvincePlaceholder,
  hideZeroBalancesStorageKey,
  isFirstCashierOpened,
  oddsStorageKey,
  personalCodePlaceholders,
  provincePlaceholders,
  quickBetSumsStorageKey,
  registrationComplete,
  selfExclusion,
  timeFormatStorageKey,
  timeZoneStorageKey,
  widgetMinimized,
  yesNoItems
};
